import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import ApercuFlottant from '../ApercuFlottant';
import ReferenceBien from './ReferenceBien';
import { useNotifications } from '../../contexts/NotificationsContext';
import { heureNotification, ICONES_TYPE } from '../../utils/heureNotification';

/** lot DJ — panneau de la cloche (ordinateur) : seulement les non lues, 10 au plus. */
export const PanneauNotifications = ({ ancreRef, onFermer, onMouseEnter, onMouseLeave }) => {
  const [lignes, setLignes] = useState(null);
  const { nonLues, rafraichir } = useNotifications();
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/notifications', { params: { vue: 'non_lues' } })
      .then(({ data }) => setLignes((data.notifications || []).slice(0, 10)))
      .catch(() => setLignes([]));
  }, []);

  const ouvrir = async (ligne, destination) => {
    try { await api.post(`/notifications/${ligne.id}/lu`); } catch (_) { /* sans gravité */ }
    rafraichir();
    onFermer();
    navigate(destination || ligne.lien);
  };

  const toutLire = async () => {
    try { await api.post('/notifications/tout-lu'); } catch (_) { /* sans gravité */ }
    setLignes([]);
    rafraichir();
  };

  return (
    <ApercuFlottant
      ancreRef={ancreRef}
      onFermer={onFermer}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        data-testid="panneau-notifications"
        className="bg-white rounded-xl shadow-2xl border border-slate-200 overflow-hidden"
      >
        {/* lot DJ2 — lien entier : le titre passe à la ligne si la place manque */}
        <div className="flex items-start justify-between gap-3 px-4 py-3 border-b border-slate-100">
          <h2 className="text-sm font-bold text-slate-900 min-w-0">
            Nouvelles notifications ({nonLues})
          </h2>
          {nonLues > 0 && (
            <button type="button" onClick={toutLire} data-testid="panneau-notifications-tout-lu"
                    className="text-xs font-semibold text-blue-600 hover:underline whitespace-nowrap shrink-0">
              Tout marquer comme lu
            </button>
          )}
        </div>

        <div className="max-h-96 overflow-auto">
          {lignes === null ? (
            <p className="text-sm text-slate-400 px-4 py-6 text-center">Chargement…</p>
          ) : lignes.length === 0 ? (
            <p className="text-sm text-slate-500 px-4 py-6 text-center"
               data-testid="panneau-notifications-vide">
              Aucune nouvelle notification
            </p>
          ) : lignes.map((ligne) => (
            /* lot DJ3 — deux liens par ligne, comme la page : titre et référence du bien */
            <div
              key={ligne.id}
              data-testid={`panneau-notification-${ligne.id}`}
              className="px-4 py-3 hover:bg-slate-50 border-b border-slate-50 flex gap-3"
            >
              <i className={`bi ${ICONES_TYPE[ligne.type] || 'bi-bell'} text-slate-400 mt-0.5`}></i>
              <div className="min-w-0 flex-1">
                <button
                  type="button"
                  onClick={() => ouvrir(ligne)}
                  data-testid={`panneau-notification-titre-${ligne.id}`}
                  className="block w-full text-left text-sm font-semibold text-slate-900 truncate hover:underline"
                >
                  {ligne.titre}
                </button>
                <p className="text-xs text-slate-600 truncate">{ligne.texte}</p>
                <ReferenceBien ligne={ligne} onOuvrir={ouvrir} prefixeTest="panneau-notification" />
                <p className="text-[11px] text-slate-400 mt-0.5">
                  Ouvre : {ligne.ouvre} · {heureNotification(ligne.created_at)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={() => { onFermer(); navigate('/notifications'); }}
          data-testid="panneau-notifications-toutes"
          className="w-full px-4 py-3 text-sm font-semibold text-blue-600 hover:bg-slate-50 border-t border-slate-100 text-left"
        >
          Voir toutes les notifications →
        </button>
      </div>
    </ApercuFlottant>
  );
};

export default PanneauNotifications;
